const typography = {
  htmlFontSize: 10,
  fontFamily: ['"Inter"', '"Helvetica Neue"', 'Arial', 'sans-serif'].join(','),
  logo: {
    fontWeight: 600,
    fontSize: '1.6rem',
    lineHeight: '2rem',
  },
  h1: {
    fontSize: '2.4rem',
    lineHeight: '2.4rem',
    fontWeight: 600,
  },
  h2: {
    fontSize: '2rem',
    lineHeight: '2.4rem',
    fontWeight: 600,
  },
  h3: {
    fontSize: '1.6rem',
    lineHieght: '2.4rem',
    fontWeight: 600,
  },
  'h2-small': {
    fontSize: '1.2rem',
    lineHeight: '2rem',
    fontWeight: 600,
  },
  body1: {
    fontSize: '1.4rem',
    lineHeight: '2.4rem',
    fontWeight: 400,
  },
  numberLg: {
    fontSize: '3.2rem',
    lineHeight: '2.4rem',
    fontWeight: 600,
  },
  numberMd: {
    fontSize: '2.2rem',
    lineHeight: '2.2rem',
    fontWeight: 600,
  },
  percent: {
    fontSize: '1.6rem',
    lineHeight: '1.9rem',
    fontWeight: 600,
  },
  numberSm: {
    fontSize: '1.6rem',
    lineHeight: '2.4rem',
    fontWeight: 600,
  },
  caption: {
    fontSize: '1.2rem',
    lineHeight: '1.6rem',
    fontWeight: 400,
  },
  captionLg: {
    fontSize: '1.4rem',
    lineHeight: '1.7rem',
    fontWeight: 500,
  },
  button: {
    fontSize: '1.4rem',
    lineHeight: '2rem',
    fontWeight: 400,
    textTransform: 'none',
  },
  buttonLg: {
    fontSize: '1.4rem',
    lineHeight: '2rem',
    fontWeight: 600,
  },
  buttonSm: {
    fontSize: '1.2rem',
    lineHeight: '2.4rem',
    fontWeight: 600,
  },
  tabCaption: {
    fontSize: '1rem',
    lineHeight: '1.4rem',
    fontWeight: 500,
  },
}

export default typography
